import {
  GET_DETAILED_WFH_DATA,
  GET_DETAILED_WFH_DATA_SUCCESS,
  GET_DETAILED_WFH_DATA_ERROR,
  GET_SUMMARY_WFH_DATA,
  GET_SUMMARY_WFH_DATA_SUCCESS,
  GET_SUMMARY_WFH_DATA_ERROR,
  EXPORT_DETAILED_WFH_DATA,
  EXPORT_DETAILED_WFH_DATA_SUCCESS,
  EXPORT_DETAILED_WFH_DATA_ERROR,
} from "./actionType"

// get detailed work from home

export const getWFH = data => {
  return {
    type: GET_DETAILED_WFH_DATA,
    payload: data,
  }
}

export const getWFHSuccess = wfhdetailed => {
  return {
    type: GET_DETAILED_WFH_DATA_SUCCESS,
    payload: wfhdetailed ? wfhdetailed : [],
  }
}
export const getWFHError = error => {
  return {
    type: GET_DETAILED_WFH_DATA_ERROR,
    payload: error,
  }
}

// summary work from home

export const getWFHsummary = data => {
  return {
    type: GET_SUMMARY_WFH_DATA,
    payload: data,
  }
}

export const getWFHsummarySuccess = wfhsummary => {
  return {
    type: GET_SUMMARY_WFH_DATA_SUCCESS,
    payload: wfhsummary,
  }
}

export const getWFHsummaryError = error => {
  return {
    type: GET_SUMMARY_WFH_DATA_ERROR,
    payload: error,
  }
}

// Export detailed work from home
export const exportWFHData = data => {
  return {
    type: EXPORT_DETAILED_WFH_DATA,
    payload: data,
  }
}

export const exportWFHDataSuccess = () => {
  return {
    type: EXPORT_DETAILED_WFH_DATA_SUCCESS,
  }
}

export const exportWFHDataError = error => {
  return {
    type: EXPORT_DETAILED_WFH_DATA_ERROR,
    payload: error,
  }
}